import { Box } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import { useStyles } from './styles'

const Image = ({ partnerId }) => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <img
        src={partnerId.src}
        alt={`Image`}
        className={classes.image}
      />
    </Box>
  )
}

export default Image

Image.propTypes = {
  partnerId: PropTypes.string,
}
